module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"close btn-close\"> <img src=\"images/btn-x.png\" alt=\"\"> </div> <h1><%- copy.headline1 %></h1> <% if (copy.image_url) { %> <img class=\"thanks-image\" src=\"<%= copy.image_url %>\" alt=\"\"> <% } %> <p><%- copy.paragraph1 %></p> <% if(copy.close_text.length > 0) { %> <div class=\"close-wrapper\"> <a class=\"mtv-close\" href=\"<%= copy.redirect_url %>\" target=\"_blank\" rel=\"noopener nofollow\"><%- copy.close_text %></a> </div> <% } %> <div class=\"share\"></div> <div class=\"sponsor\"> <span><%= copy.sponsor_text %></span> <img src=\"<%= copy.sponsor_logo %>\" alt=\"\"> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="close btn-close"> <img src="images/btn-x.png" alt=""> </div> <h1>', (__stack.lineno=1,  copy.headline1 ), '</h1> ');__stack.lineno=1; if (copy.image_url) { ; buf.push(' <img class="thanks-image" src="', escape((__stack.lineno=1,  copy.image_url )), '" alt=""> ');__stack.lineno=1; } ; buf.push(' <p>', (__stack.lineno=1,  copy.paragraph1 ), '</p> ');__stack.lineno=1; if(copy.close_text.length > 0) { ; buf.push(' <div class="close-wrapper"> <a class="mtv-close" href="', escape((__stack.lineno=1,  copy.redirect_url )), '" target="_blank" rel="noopener nofollow">', (__stack.lineno=1,  copy.close_text ), '</a> </div> ');__stack.lineno=1; } ; buf.push(' <div class="share"></div> <div class="sponsor"> <span>', escape((__stack.lineno=1,  copy.sponsor_text )), '</span> <img src="', escape((__stack.lineno=1,  copy.sponsor_logo )), '" alt=""> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/thanks.ejs
// module id = 242
// module chunks = 0